import { __awaiter } from 'tslib';

const ENDPOINT = 'POSTresendverificationemail';
function postResendVerificationEmail(gateway, params, customURL = null, customHeaders = null, isKoussa = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.post(postResendVerificationEmail.endpoint, isKoussa ? {} : params, params, customURL, customHeaders, null, isKoussa);
    });
}
postResendVerificationEmail.endpoint = ENDPOINT;

export { postResendVerificationEmail as default };
//# sourceMappingURL=postResendVerificationEmail.js.map
